var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"light","content":_vm.label,"placement":"bottom","open-delay":200,"disabled":_vm.label == ''}},[_c('img',{staticClass:"mode-select-item flex-center",class:[_vm.value == _vm.mode.mValue ? 'mode-select-item-active' : ''],attrs:{"src":_vm.img},on:{"click":_vm.clickItem}})])
}
var staticRenderFns = []

export { render, staticRenderFns }